const toBase64 = (str: string) => btoa(unescape(encodeURIComponent(str)))
const fromBase64 = (str: string) => decodeURIComponent(escape(atob(str)))

export const encryptId = (id: any) => {
  if (id === null || id === undefined) {
    console.error('encryptId received null or undefined:', id)
    return ''
  }
  const randomString =
    Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  const encodedId = toBase64(id.toString())
  return toBase64(`${randomString}-${encodedId}`)
}

export const decryptId = (id: any) => {
  const decodedX = fromBase64(id)
  const x = decodedX.split('-')[1]
  const decodedValue = fromBase64(x)
  return decodedValue
}
